/*
Ravi 04/24/2023 3075154998 Added popup in dynamic field name
Akhila 06/20/2023 3075154998 bug fix implemented line waise values
*/
import {Button, TextField} from '@material-ui/core';
import {Form, Formik} from 'formik';
import React, {useRef} from 'react';
import {useContext} from 'react';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';
import AddRuleSelectField from '../../../../BRE/FormulaRuleGroup/StepperRuleGroup/AddRule/AddRuleSelectField';
import '../../../../BRE/FormulaRuleGroup/StepperRuleGroup/AddRule/styles.scss';


const AddFileName = ({handleClose, setFieldValues, addValues, export: exp, exportType}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const fieldNameTypeOptions = [
    {key: 'Date', value: 'Date - {YYYYMMDD}'},
    {key: 'Date', value: 'Date - {MMDDYYYY}'},
    {key: 'Date', value: 'Date - {YYMMDD}'},
    {key: 'Date', value: 'Date - {MMDDYY}'},
    {key: 'Date', value: 'Date - {YYMM}'},
    {key: 'Date', value: 'Date - {MMYY}'},
    {key: 'DateTime', value: 'Date Time - {MMDDYYYYHHmmSS}'},
    {key: 'ReportCode', value: 'Name - {Name}'},
    {key: 'DateTime', value: 'Executed By - {EXECUTED_BY}'},
  ];
  const importCondition = exportType === "Import" ? true : false
  const placeholderName =  importCondition ? 'Exception' : exp ? 'Export' : 'Report';

  const expressionRef = useRef();
  const initialValues = {
    fields: null,
    expression: addValues?.outputFileName ? addValues?.outputFileName : '',
  };

  const handleSubmit = (values) => {
    setFieldValues('outputFileName', values?.expression);
    handleClose();
  };

  return (
    <Formik initialValues={initialValues} enableReinitialize onSubmit={handleSubmit}>
      {(props) => {
        const {
          values,
          handleChange,
          setFieldValue,
          resetForm,
        } = props;
        return (
          <Form>
            <div
              style={{
                // display: "flex",
                padding: '0rem 1.8rem',
              }}
            >
              <div className="row">
                <AddRuleSelectField
                  label={'File Name'}
                  options={fieldNameTypeOptions}
                  optionLable={(option) => option && option?.value}
                  handleChange={(_, value) => {
                    setFieldValue('fields', value);
                  }}
                  placeholder="Select File Name"
                  value={values.fields}
                  handleInsert={() => {
                    const selectedFunc = values?.fields?.value?.split('-')[1];
                    console.log(selectedFunc, 'selectedFunc') ?
                      `${values?.fields?.value?.split('-')[1]}` :
                      '';
                    if (values.expression) {
                      // setFieldValue(
                      //   "expression",
                      //   values.expression?.slice(0, cursorPosition) +
                      //     selectedFunc +
                      //     values.expression.slice(cursorPosition)
                      // );
                      setFieldValue(
                        'expression',
                        values.expression?.slice(0) + selectedFunc,
                        // +
                        //   values.expression.slice(selectedFunc?.length)
                      );
                      expressionRef.current.focus();
                    } else {
                      setFieldValue('expression', selectedFunc);
                    }
                  }}
                />
              </div>

              <div className="expression-textfield new-standard-textfields">
                <TextField
                  margin="dense"
                  variant="outlined"
                  placeholder={`Enter ${placeholderName} Output File Name`}
                  // className={` ${classes.labelName} ${classes.inputLabel} `}
                  label={`${placeholderName} Output File Name`}
                  multiline
                  minRows={2}
                  maxRows={2}
                  // InputLabelProps={{
                  //   shrink: true,
                  // }}
                  name="expression"
                  required
                  value={values.expression}
                  onChange={(e) => {
                    //   setExpression(e?.target?.value);
                    handleChange(e);
                  }}
                  // onBlur={handleBlur}
                  inputRef={expressionRef}
                  fullWidth
                  // touched={touched.expression}
                  // error={Boolean(touched.expression && errors.expression)}
                />
              </div>
              <div className="d-flex justify-content-center new-standard-textfields">
                <Button
                  variant="outlined"
                  onClick={() => {
                    resetForm(initialValues);
                  }}
                  className={`reset-btn mx-1 ${classes.buttonRoot}`}
                >
                  Reset
                </Button>

                <Button
                  type="submit"
                  variant="outlined"
                  className={`search-btn mx-1 ${classes.buttonRoot} `}
                >
                  Save
                </Button>
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default AddFileName;
